import React, { FC } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { EvLinkNavigationTabs } from '@evinced-private/ui-common';

import { useBusinessUnitLabelDisplayName } from '../../helpers/BusinessUnitLabelHelper';
import {
	createDashboardTabOptions,
	getActiveTabFromPath
} from '../../helpers/TabNavigationHelpers';

export const DashboardTabsNav: FC = () => {
	const history = useHistory();
	const { pathname } = useLocation();
	const businessUnitDisplayName = useBusinessUnitLabelDisplayName();

	const activeTabId = getActiveTabFromPath(pathname);
	const options = createDashboardTabOptions(history, businessUnitDisplayName);

	return <EvLinkNavigationTabs selectedTabId={activeTabId} options={options} />;
};
